import React, { useState, useEffect } from "react";
import {Col, Container, Row} from "react-bootstrap";
import BannerImg from "../../images/events/recent-events.png";
import {LazyLoadImage} from "react-lazy-load-image-component";
import {Link} from 'gatsby';

function Recentevent(props) {
    return (
        <div className="recent-event p-100">
            <Container>
                <Row>
                    <Col xs={12} md={6} lg={6} xl={6} xxl={6}>
                        <div className="example" data-text="recent">
                            <h2>Recent Event:</h2>
                        </div>
                    </Col>
                </Row>
            </Container>

            <Container fluid>
                <Row>
                    <Col xs={12} md={12} lg={12} xl={6} xxl={6}>
                        <div className="recent-img" >
                            <LazyLoadImage
                                src={BannerImg}
                                effect="blur" alt="latest-events" className="img-fluid"
                            />
                        </div>
                    </Col>
                    <Col xs={12} md={12} lg={12} xl={6} xxl={6} className="my-auto">
                        {/*<div className="recent-content">*/}
                            {/*<h4>Technology For Change</h4>*/}
                            {/*<h4><b>Date:</b> 22-July-2020</h4>*/}
                            {/*<h4><b>Venue:</b> <Link to="https://www.facebook.com/TekRevolOfficial/">https://www.facebook.com/tekrevolofficial</Link></h4>*/}
                        {/*</div>*/}
                        <Row className="margin-leftextrabox">
                            <Col xs={12} md={6} lg={3} xl={3} xxl={3}>
                                <div className="recent-all">
                                    <div className="recent-counter">
                                        <div className="recent-number">
                                            <h4>06</h4>
                                        </div>
                                    </div>
                                    <div className="recent-bottom">
                                        <p>Days</p>
                                    </div>
                                </div>
                            </Col>
                            <Col xs={12} md={6} lg={3} xl={3} xxl={3}>
                                <div className="recent-all">
                                    <div className="recent-counter">
                                        <div className="recent-number">
                                            <h4>07</h4>
                                        </div>
                                    </div>
                                    <div className="recent-bottom">
                                        <p>hours</p>
                                    </div>
                                </div>
                            </Col>
                            <Col xs={12} md={6} lg={3} xl={3} xxl={3}>
                                <div className="recent-all">
                                    <div className="recent-counter">
                                        <div className="recent-number">
                                            <h4>36</h4>
                                        </div>
                                    </div>
                                    <div className="recent-bottom">
                                        <p>months</p>
                                    </div>
                                </div>
                            </Col>
                            <Col xs={12} md={6} lg={3} xl={3} xxl={3}>
                                <div className="recent-all">
                                    <div className="recent-counter">
                                        <div className="recent-number">
                                            <h4>11</h4>
                                        </div>
                                    </div>
                                    <div className="recent-bottom">
                                        <p>second</p>
                                    </div>
                                </div>
                            </Col>
                        </Row>

                    </Col>
                </Row>
            </Container>
        </div>
    );
}

export default Recentevent;